module.exports = __webpack_public_path__ + "static/img/payment-1.a7e02e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/payment-1.png
// module id = I1ca
// module chunks = 1